import React, { useRef } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import YandexMap from '../Components/YandexMap';
import Loading from '../Components/Loading';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import MainPhotosCarousel from '../Components/MainPhotosCarousel';

import styles from '../Styles/Index.module.css';

const Index = () => {
  const roomCardsRef = useRef(null);
  const { openTimeModal } = useTimeModal();

  const [warning, setWarning] = React.useState('');
  const [loading, setLoading] = React.useState(true);

  const [formInfo, setFormInfo] = React.useState({
      id: '',
  });

  const scrollToRooms = () => {
    if (roomCardsRef.current) {
      const elementPosition = roomCardsRef.current.getBoundingClientRect().top;
      const offsetPosition = window.scrollY + elementPosition - 110;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  const [photo, setPhoto] = React.useState([]);
  React.useEffect(() => {
      axios.get('/api/site-super-main-photo')
      .then((response) => {
          setPhoto(response.data);
      })
  }, []);

  React.useEffect(() => {
    if (window.homereserve) {
      window.homereserve.initWidgetSearch({ 
        token: "5BsxlnkL15",
        navigation: false, 
        instance_id: 'search',
        tag: 'Сайт',
      }); 

      window.homereserve.initWidgetList({ 
      token: "5BsxlnkL15",
      navigation: false, 
      instance_id: 'list',
      tag: 'Сайт',
      }); 
    }
  }, [loading]);

  React.useEffect(() => {
      axios.get('/api/get-fields')
      .then((response) => {
          setFormInfo(response.data);
      }).catch(error => {
          setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
      })
      .finally(() => {
          setLoading(false);
      });
  }, []);

  return (
    <>
      {loading ? <Loading />
      :
      <>
      <Header formInfo={formInfo} />
      <div className={styles.mainBlock} style={{background: `linear-gradient(rgba(0, 0, 0, 0.508), rgba(0, 0, 0, 0.3)), url("${photo.path ? photo.path.replace(/\\/g, '/') : ''}")`}}>
        <div className={styles.headlineCenter}>
          <h1>{formInfo?.company_name || 'Taksa House'}</h1>
          <a>{formInfo?.mainh2}</a>
          <button className={styles.mainButton} onClick={scrollToRooms}>
            Просмотреть квартиры
          </button>
        </div>
      </div>

      <div className='main' style={{marginTop: '30px', marginBottom: '30px', padding: '0 10px', boxSizing: 'border-box'}} ref={roomCardsRef}>
        <div style={{marginBottom: '15px'}} id="hr-widget" data-instance-id="search"></div>
        <div id="hr-widget" data-instance-id="list"></div>
      </div>

      <div className='main'>
        <div className={styles.panelUnder}>
          <MainPhotosCarousel />
        </div>
      </div>

      <div className='main'>
        <div className={styles.panelUnder}>
          <div className={styles.panel}>
            <h2>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="check-circle"><path fill="#6563FF" d="M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"></path></svg>
              {formInfo?.h2}
            </h2>

            <h3>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="corner-down-right"><path fill="#0a9f3c" d="M19.61,16a1.19,1.19,0,0,0-.22-.33L14.76,11a1,1,0,0,0-1.41,1.41l2.92,2.92h-7a3,3,0,0,1-3-3V3a1,1,0,1,0-2,0v9.37a5,5,0,0,0,5,5h7l-2.92,2.92a1,1,0,0,0,0,1.42,1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l4.63-4.63a1,1,0,0,0,.22-.33A1,1,0,0,0,19.61,16Z"></path></svg>
              {formInfo?.firsth3}
            </h3>
            <p>
              <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                  p: ({node, ...props}) => <p style={{whiteSpace: 'pre-wrap'}} {...props} />
              }}
              breaks
              >
              {formInfo?.firsttextarea}
              </ReactMarkdown>
            </p>
            <h3>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="corner-down-right"><path fill="#6563FF" d="M19.61,16a1.19,1.19,0,0,0-.22-.33L14.76,11a1,1,0,0,0-1.41,1.41l2.92,2.92h-7a3,3,0,0,1-3-3V3a1,1,0,1,0-2,0v9.37a5,5,0,0,0,5,5h7l-2.92,2.92a1,1,0,0,0,0,1.42,1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l4.63-4.63a1,1,0,0,0,.22-.33A1,1,0,0,0,19.61,16Z"></path></svg>
              {formInfo?.secondh3}
            </h3>
            <p>
              <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                  p: ({node, ...props}) => <p style={{whiteSpace: 'pre-wrap'}} {...props} />
              }}
              breaks
              >
              {formInfo?.secondtextarea}
              </ReactMarkdown>
            </p>
            <h3>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="corner-down-right"><path fill="#45118a" d="M19.61,16a1.19,1.19,0,0,0-.22-.33L14.76,11a1,1,0,0,0-1.41,1.41l2.92,2.92h-7a3,3,0,0,1-3-3V3a1,1,0,1,0-2,0v9.37a5,5,0,0,0,5,5h7l-2.92,2.92a1,1,0,0,0,0,1.42,1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l4.63-4.63a1,1,0,0,0,.22-.33A1,1,0,0,0,19.61,16Z"></path></svg>
              {formInfo?.thirdh3}
            </h3>
            <p>
              <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                  p: ({node, ...props}) => <p style={{whiteSpace: 'pre-wrap'}} {...props} />
              }}
              breaks
              >
              {formInfo?.thirdtextarea}
              </ReactMarkdown>
            </p>
          </div>
        </div>
      </div>

      <div className='main'>
        <div className={styles.panelUnder}>
          <div className={styles.panel} style={{backgroundColor: '#cee2ff', color: '#0a469f', borderColor: '#0a469f'}}>
          <h2>Готовы забронировать?</h2>
          <svg xmlns="http://www.w3.org/2000/svg" style={{position: 'absolute', right: '16px', top: '5px'}} id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="42" height="42"><path fill="#0a469f" d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm5.665,16.587l-.522,.6c-.551,.552-1.277,.813-2,.813-3.714,0-9.143-5.143-9.143-9.143,0-.723,.261-1.449,.813-2l.6-.522c.446-.446,1.17-.446,1.616,0l1,1.302c.446,.446,.446,1.17,0,1.616l-.851,1.069c.901,2.244,2.429,3.71,4.5,4.5l1.069-.851c.446-.446,1.17-.446,1.616,0l1.302,1c.446,.446,.446,1.17,0,1.616Z"/></svg>
          <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
            <p>Позвоните нам по номеру:</p> 
            <div style={{display: 'flex', alignItems: 'center'}}>
              <a href={`tel:${formInfo?.phone_number}`}>{formInfo?.phone_number}</a>
              {formInfo?.phone_number_additional && 
              <>
                <p>/</p>
                <a href={`tel:${formInfo?.phone_number_additional}`}>{formInfo?.phone_number_additional}</a>
              </>}
            </div>
          </div>
        </div>
        </div>
      </div>

      <div className='main'>
        <div className={styles.panelUnder}>
          <div className={styles.panel}>
            <h2>Расположение</h2>
            <a className='description' style={{marginBottom: '10px'}}>{formInfo?.address}</a>
            <YandexMap />
          </div>
        </div>
      </div>
      <Footer formInfo={formInfo} />
      </>}
    </>
  );
};

export default Index;
